import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../../../components-v2/Theme/theme';
import { aceGray, error, shuffleGray, white } from '../../../../../styles/colors';
import { CssSelectors } from '../../../../../styles/styles';

const generatingContentAnimation = {
	'0%': {
		backgroundPosition: '0% 50%',
	},
	'50%': {
		backgroundPosition: '100% 50%',
	},
	'100%': {
		backgroundPosition: '0% 50%',
	},
};

export const styleSheet = StyleSheet.create({
	recipientsList: {
		overflow: 'auto',
	},
	templatesList: {
		display: 'flex',
		flexDirection: 'column',
		gap: 32,
		overflow: 'auto',
		padding: '20px 20px 20px 24px',
	},
	tagTokenContainer: {
		maxHeight: 'unset',
		...CssSelectors.allChildren({
			marginLeft: '0.5rem',
		}),
	},
	contentContainer: {
		':hover': {
			cursor: 'pointer',
		},
		...CssSelectors.allChildren(
			{
				fontSize: 14,
			},
			':first-child:not(.tag):not(.saved-search)'
		),
		...CssSelectors.allChildren(
			{
				alignItems: 'center',
				display: 'flex',
				marginLeft: 8,
				textTransform: 'capitalize',
			},
			':last-child'
		),
		...CssSelectors.allChildren(
			{
				marginLeft: 0,
			},
			'.saved-search'
		),
	},
	itemsContainer: {
		':last-child': {
			marginBottom: 0,
		},
		marginBottom: 8,
	},
	pill: {
		borderRadius: 30,
		fontSize: 12,
		padding: '3px 10px',
		...CssSelectors.allChildren(
			{
				height: 13,
				marginRight: 8,
				width: 13,
			},
			'svg'
		),
	},
	emailEditorContainer: {
		position: 'relative',
		backgroundColor: `${shuffleGray}80`,
		border: `1px solid ${aceGray}`,
		borderRadius: 8,
		height: 176,
		overflow: 'hidden',
		paddingLeft: 10,
	},
	editorContainerError: {
		border: `1px solid ${error}`,
	},
	emailEditorStyles: {
		width: '100%',
		height: '100%',
		overflow: 'auto',
	},
	emailSuccess: {
		paddingTop: 60,
	},
	generatingContent: {
		position: 'absolute',
		top: 0,
		left: 0,
		right: 0,
		bottom: 0,
		backgroundImage: `linear-gradient(to right,color-mix(in oklab, ${THEME.colors.primary.main} 50%, white), color-mix(in oklab, ${THEME.colors.tertiary.dark} 50%, white))`,
		backgroundSize: '180% 180%',
		backdropFilter: 'opacity(30%)',
		animationName: [generatingContentAnimation],
		animationDuration: '9s',
		animationIterationCount: 'infinite',
		border: `1px solid ${aceGray}`,
		borderRadius: 8,
		padding: 10,
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		justifyContent: 'center',
		overflow: 'hidden',
		opacity: 0,
		transition: 'opacity .3s ease-in-out, z-index .3s ease-in-out',
		zIndex: -1,
		...CssSelectors.allChildren({
			color: white,
		}),

		...CssSelectors.allChildren(
			{
				'--size': '20vmin',
				'--holes': 'calc(var(--size)*.495)',
				width: 'var(--size)',
				aspectRatio: '1/1',
				position: 'fixed',
				background: white,
				'--mask':
					'radial-gradient(var(--holes) at var(--holes) var(--holes), #0000 99%,#000) calc(var(--holes)*-1) calc(var(--holes)*-1)',
				'-webkit-mask': 'var(--mask)',
				mask: 'var(--mask)',
				borderRadius: '50%',
				animation: '1s linear forwards',
				animationName: [
					{
						'0%': { transform: 'scale(0)' },
						'25%': { opacity: 1 },
						'100%': { opacity: 0 },
					},
				],
			},
			'.star'
		),
	},
	generatingContentActive: {
		opacity: 1,
		zIndex: 999,
	},
});
